module.exports = __webpack_public_path__ + "img/23_45.c29a0db5.png";